module.exports = __webpack_public_path__ + "media/reskin-images/img--field-notes-96cca19b.png";